import React, { Component } from 'react';
import './beer-grid.scss';

class BeersGrid extends Component{
  constructor(props) {
    super(props);
  }

  render() {
    const { content } = this.props;    
    return (
      <div className='beers-grid'>
        {content.map((item) => (
          <div className="beers-grid__item">
            <h3>{item[0].value}</h3>
            <h3 className="abv">{item[1].value}</h3>
            <p className='tastingNotes'>{item[2].value}</p>
          </div>
        ))}
      </div>
    );
  }
}

export default BeersGrid;



// WEBPACK FOOTER //
// ./src/components/BeersGrid/index.js